import { AsyncStoreItem } from '@lib';
import { WarnInner } from 'src/sdk_checkin';

/**
 * CheckinPassengerAdditionResult model
 */
export interface CheckinPassengerAdditionResultModel {
  warnings?: WarnInner[];
}

/**
 *  model details
 */
export interface CheckinPassengerAdditionResultStateDetails extends AsyncStoreItem {}

/**
 * CheckinPassengerAdditionResult store state
 */
export interface CheckinPassengerAdditionResultState
  extends CheckinPassengerAdditionResultStateDetails,
    CheckinPassengerAdditionResultModel {}

/**
 * Name of the CheckinPassengerAdditionResult Store
 */
export const CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME = 'checkinPassengerAdditionResult';

/**
 * CheckinPassengerAdditionResult Store Interface
 */
export interface CheckinPassengerAdditionResultStore {
  /** CheckinPassengerAdditionResult state */
  [CHECKIN_PASSENGER_ADDITION_RESULT_STORE_NAME]: CheckinPassengerAdditionResultState;
}
